var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 20.9997V18.7775C21 17.5987 20.4732 16.4683 19.5355 15.6348C18.5979 14.8013 17.3261 14.333 16 14.333H6C4.67392 14.333 3.40215 14.8013 2.46447 15.6348C1.52678 16.4683 1 17.5987 1 18.7775V20.9997",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.88889C13.7614 9.88889 16 7.89904 16 5.44444C16 2.98985 13.7614 1 11 1C8.23858 1 6 2.98985 6 5.44444C6 7.89904 8.23858 9.88889 11 9.88889Z",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIco);
export default __webpack_public_path__ + "static/media/profileIco.c0c72185fb043cb8364b03a3fc4574b5.svg";
export { ForwardRef as ReactComponent };